import React, { ImgHTMLAttributes, useCallback } from "react";
import { LineupOption } from "../types";

export const useAthleteImgProps = () => {
  return useCallback(
    (athlete: LineupOption): ImgHTMLAttributes<HTMLImageElement> => {
      return {
        src: athlete.image_url,
        alt: athlete.name,
        "aria-label": athlete.name,
      };
    },
    []
  );
};
